import { atom } from 'recoil';

/**
 * TransferPhotoListAtom - 앱 전송용 사진 리스트
 *
 * 구조:
 * - savedFileName: 서버에 저장된 파일명 (캡처 이미지는 null)
 * - thumbnailUrl: 미리보기 URL
 * - fileUrl: 원본 파일 URL (서버 이미지만)
 * - originalFileName: 원본 파일명
 * - file: File 객체 (캡처 이미지만)
 * - source: 'server' | 'capture'
 */
export const TransferPhotoListAtom = atom({
  key: 'TransferPhotoListAtom',
  default: []
});

/**
 * TransferPhotoDeleteRequestAtom - 앱 전송용 사진 삭제 요청 리스트
 * savedFileName 배열
 */
export const TransferPhotoDeleteRequestAtom = atom({
  key: 'TransferPhotoDeleteRequestAtom',
  default: []
});

/**
 * TransferPhotoFileKeyAtom - 앱 전송용 사진 파일 키
 * 서버에서 조회 시 받아온 fileKey (없으면 null)
 */
export const TransferPhotoFileKeyAtom = atom({
  key: 'TransferPhotoFileKeyAtom',
  default: null
});

/**
 * FileChangedGroupIdsAtom - 파일 변경(저장)이 발생한 markerGroup ID 목록
 * savePhotos 실행 시 해당 originId가 추가됨
 * resetRecoilState 시 초기화됨
 */
export const FileChangedGroupIdsAtom = atom({
  key: 'FileChangedGroupIdsAtom',
  default: []
});